<template>
  <div class="flex flex-col h-full mt-4">
    <!-- Enhanced Header Bar -->
    <div class="bg-white p-4 mb-4 rounded-lg shadow">
      <div class="flex flex-col gap-4">
        <!-- Top row with scan and repair button -->
        <div class="flex justify-between items-center">
          <div class="text-xl font-semibold text-gray-800">
            LOLER Testing
          </div>
          <div class="flex items-center gap-3">
            <div class="w-48">
              <InputText
                id="return"
                v-model="returnValue"
                placeholder="Scan Asset..."
                type="text"
                class="w-full"
              />
            </div>
          </div>
        </div>

        <!-- View type selector -->
        <div class="flex gap-4 items-center">
          <ButtonGroup>
            <Button
              label="By Asset"
              :class="{ 'bg-symphony-yellow-500 text-black': viewType === 'asset' }"
              class="flex-1 md:flex-none"
              severity="secondary"
              raised
              @click="viewType = 'asset'"
            />
            <Button
              label="By Barcode"
              :class="{ 'bg-symphony-yellow-500 text-black': viewType === 'barcode' }"
              class="flex-1 md:flex-none"
              severity="secondary"
              raised
              @click="viewType = 'barcode'"
            />
          </ButtonGroup>
        </div>
      </div>
    </div>

    <!-- Data Table -->
    <div class="flex-1 bg-white rounded-lg shadow overflow-hidden">
      <DataTable
        v-if="viewType == 'asset'"
        :value="tests"
        sort-field="name"
        scrollable
        scroll-height="550px"
        class="h-full"
        table-style="width: 100%"
        striped-rows
      >
        <template #empty>
          <div class="flex flex-wrap items-center justify-center p-4">
            <p>No LOLER tests are due.</p>
          </div>
        </template>

        <Column
          field="assetName"
          header="Asset"
          sortable
          :style="{ width: '35%', minWidth: '350px' }"
        />
        <Column
          field="overdue"
          header="# Overdue"
          sortable
          :style="{ width: '15%', minWidth: '100px' }"
        />
        <Column
          field="thisMonth"
          header="Due This Month"
          sortable
          :style="{ width: '25%', minWidth: '200px' }"
        />
        <Column
          field="nextMonth"
          header="Due Next Month"
          sortable
          :style="{ width: '25%', minWidth: '200px' }"
        />
      </DataTable>

      <DataTable
        v-else
        :value="tests"
        sort-field="name"
        scrollable
        scroll-height="550px"
        class="h-full"
        table-style="width: 100%"
        striped-rows
      >
        <template #empty>
          <div class="flex flex-wrap items-center justify-center p-4">
            <p>No LOLER tests are due.</p>
          </div>
        </template>

        <Column
          field="barcode"
          header="Barcode"
          sortable
          :style="{ width: '20%', minWidth: '150px' }"
        />
        <Column
          field="assetName"
          header="Item"
          sortable
          :style="{ width: '40%', minWidth: '300px' }"
        />
        <Column
          field="dueDate"
          header="Due Date"
          sortable
          :style="{ width: '40%', minWidth: '200px' }"
        />
      </DataTable>
    </div>
  </div>
</template>

<script setup>
//Primevue Imports

import { ref, onMounted } from 'vue';
import { createTests } from '@/data/faker'

const tests = ref()
const returnValue = ref('');
const viewType = ref('asset')

// Populate data when the component is mounted
onMounted(() => {
    tests.value = createTests(50); // Generate 50 tests
});
</script>

<style scoped>
/* Override any potential max-width constraints */
:deep(.p-datatable),
:deep(.p-datatable-wrapper),
:deep(.p-datatable-table),
:deep(.p-datatable-tbody),
:deep(.p-datatable-thead) {
    width: 100% !important;
    max-width: 100% !important;
}

/* Make sure columns distribute properly */
:deep(.p-datatable-table) th,
:deep(.p-datatable-table) td {
    width: auto !important;
}

/* Style for active buttons */
:deep(.p-button.bg-symphony-yellow-500) {
    background-color: var(--symphony-yellow-500);
    border-color: var(--symphony-yellow-500);
    color: black;
}

:deep(.p-button.bg-symphony-yellow-500:hover) {
    background-color: var(--symphony-yellow-600);
    border-color: var(--symphony-yellow-600);
}

/* Fix for ButtonGroup in mobile view */
@media (max-width: 768px) {
    :deep(.p-buttongroup) {
        width: 100%;
    }
}
</style>
